/**
 * SignUpPresenter
 * --
 */
import React from 'react';
import { Content, Row, Col, Title, Text, TopBanner } from 'components';
import { Button, Input, Radio, Checkbox, Flex, Image } from 'antd';
import { openAddressModal } from 'utils/DaumAPIManager';
import Formatter from 'utils/Formatter';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { DOMAIN_URL, STORE_URL } from 'utils';

const SignUpPresenter = ({
  inputRef,
  inputValue,
  message,
  status,
  screenSize,
  checkedList,
  checkedAll,

  checkListItem,
  isDuplicate,
  isAuthCheck,
  authCode,
  timeText,
  authStatus,
  inputAuthCode,

  isBiz = false,
  bizInfo,
  setBizInfo,

  onChange,
  onSubmit,
  navigate,
  onChecked,
  onCheckedAll,
  onDuplicate,
  onOpen,
  onSendAuthCode,
  onAuthCode,
  setInputAuthCode,

  social,

  setMonthUse,
  monthUse,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const fileRef = React.useRef(null);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 32 : 28,
      lineHeight: '120%',
      fontFamily: `"Dela Gothic One", sans-serif`,
      fontWeight: 400,
      fontStyle: 'normal',
      color: 'var(--black-color)',
    },

    infoText: {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: '200%',
      color: 'var(--light-gray-color)',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },

    label: {
      display: 'flex',
      alignItems: 'center',
      color: 'var(--black-color)',
      fontSize: screenSize >= 768 ? 16 : 14,
      paddingLeft: 8,
      fontWeight: 400,
      lineHeight: '150%',
      marginBottom: screenSize >= 768 ? 12 : 4,
    },

    required: {
      color: 'var(--danger-color)',
      padding: '0px 4px',
      lineHeight: 0,
    },

    input: {
      width: '100%',
      height: screenSize >= 768 ? 44 : 38,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '180%',
    },

    message: {
      fontSize: 12,
      fontWeight: 400,
      color: 'var(--danger-color)',
      position: 'absolute',
      top: '100%',
      left: 8,
      whiteSpace: 'nowrap',
      lineHeight: '175%',
      // display: status === 'default' ? 'none' : 'inline-block',
    },

    button: {
      fontSize: screenSize >= 768 ? 16 : 12,
      fontWeight: 700,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: 'none',
    },

    submitButton: {
      width: '100%',
      height: screenSize >= 768 ? 58 : 40,
      background: 'var(--black-color)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: screenSize >= 768 ? 16 : 15,
      lineHeight: '100%',
      fontWeight: 700,
      color: 'var(--white-color)',
    },

    text: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: '150%',
      color: 'var(--black-color)',
    },

    checkbox: {
      fontSize: screenSize >= 768 ? 16 : 14,
      fontWeight: 400,
      color: 'var(--black-color)',
    },
  };

  const formItem = [
    !social && {
      label: '아이디',
      required: true,
      form: [
        {
          key: 'user_account',
          input: (
            <Input
              ref={(el) => (inputRef['user_account'] = el)}
              value={inputValue.account}
              onChange={(e) => onChange('user_account', e.target.value)}
              placeholder="아이디를 입력해주세요."
              style={{ ...styles.input }}
              disabled={isDuplicate['user_account']}
            />
          ),
          x: 18,
        },
        {
          input: (
            <Button
              type="primary"
              style={{ ...styles.button }}
              onClick={() =>
                onDuplicate('user_account', inputValue?.user_account)
              }
              disabled={isDuplicate['user_account']}
            >
              중복확인
            </Button>
          ),
          x: 6,
        },
      ],
    },
    !social && {
      label: '비밀번호',
      required: true,
      form: [
        {
          key: 'password',
          input: (
            <Input.Password
              ref={(el) => (inputRef['password'] = el)}
              value={inputValue.password}
              onChange={(e) => onChange('password', e.target.value)}
              placeholder="비밀번호를 입력해주세요."
              style={{ ...styles.input }}
            />
          ),
          x: 18,
        },
      ],
    },
    !social && {
      label: '비밀번호 확인',
      required: true,
      form: [
        {
          key: 're_password',
          input: (
            <Input.Password
              ref={(el) => (inputRef['re_password'] = el)}
              value={inputValue.re_password}
              onChange={(e) => onChange('re_password', e.target.value)}
              placeholder="비밀번호를 한번 더 입력해주세요."
              style={{ ...styles.input }}
            />
          ),
          x: 18,
        },
      ],
    },
    {
      label: '이름',
      required: true,
      form: [
        {
          key: 'user_name',
          input: (
            <Input
              ref={(el) => (inputRef['user_name'] = el)}
              value={inputValue.user_name}
              onChange={(e) => onChange('user_name', e.target.value)}
              placeholder="본인인증을 진행해주세요"
              style={{ ...styles.input }}
              readOnly
              disabled
            />
          ),
          x: 18,
        },
      ],
    },
    {
      label: '휴대폰',
      required: true,
      form: [
        {
          key: 'user_phone',
          input: (
            <Input
              ref={(el) => (inputRef['user_phone'] = el)}
              value={inputValue.user_phone}
              onChange={(e) => onChange('user_phone', e.target.value)}
              placeholder="본인인증을 진행해주세요"
              style={{ ...styles.input }}
              readOnly
              disabled
            />
          ),
          x: 18,
        },
        {
          input: (
            <Button
              type="primary"
              style={{ ...styles.button }}
              onClick={() => onOpen()}
              disabled={isAuthCheck}
            >
              본인인증
            </Button>
          ),
          x: 6,
        },
      ],
    },
    !social && {
      label: '이메일',
      // required: true,
      form: [
        {
          key: 'user_email',
          input: (
            <Input
              ref={(el) => (inputRef['user_email'] = el)}
              value={inputValue.user_email}
              onChange={(e) => onChange('user_email', e.target.value)}
              placeholder="예: jmcoffee@jm.co.kr"
              style={{ ...styles.input }}
              disabled={isDuplicate['user_email']}
            />
          ),
          x: 18,
        },
        {
          input: (
            <Button
              type="primary"
              style={{ ...styles.button }}
              onClick={() => onSendAuthCode()}
              disabled={authStatus === 'success'}
            >
              {authCode
                ? authStatus !== 'success'
                  ? '재전송'
                  : '인증완료'
                : '이메일인증'}
            </Button>
          ),
          x: 6,
        },
        ...(authCode
          ? [
              {
                key: 'inputAuthCode',
                input: (
                  <Input
                    ref={(el) => (inputRef['inputAuthCode'] = el)}
                    value={inputAuthCode}
                    onChange={(e) => setInputAuthCode(e.target.value)}
                    placeholder={`인증번호 6자리를 입력해 주세요.`}
                    style={{ ...styles.input, marginTop: 10 }}
                    disabled={authStatus === 'success'}
                    maxLength={6}
                    suffix={
                      <p
                        style={{
                          color: 'var(--danger-color)',
                        }}
                      >
                        {timeText}
                      </p>
                    }
                  />
                ),
                x: 18,
              },
              {
                input: (
                  <Button
                    type="primary"
                    style={{ ...styles.button, marginTop: 10, height: 44 }}
                    onClick={onAuthCode}
                    disabled={authStatus === 'success'}
                  >
                    {authStatus === 'success' ? '인증완료' : '확인'}
                  </Button>
                ),
                x: 6,
              },
            ]
          : []),
      ],
    },
    {
      label: '주소',
      required: true,
      form: [
        {
          key: 'postcode',
          input: (
            <Input
              value={inputValue.postcode}
              placeholder="우편번호"
              style={{ ...styles.input }}
              readOnly
            />
          ),
          x: 12,
        },
        {
          input: (
            <Button
              type="primary"
              style={{ ...styles.button }}
              onClick={() => handleAddressModal()}
            >
              주소 찾기
            </Button>
          ),
          x: 6,
        },
        { input: <></>, x: 6 },
        {
          key: 'user_address',
          input: (
            <Input
              value={inputValue.user_address}
              placeholder="기본주소"
              style={{ ...styles.input, marginTop: 16 }}
              readOnly
            />
          ),
        },
        {
          key: 'user_address_detail',
          input: (
            <Input
              ref={(el) => (inputRef['user_address_detail'] = el)}
              value={inputValue.user_address_detail}
              onChange={(e) => onChange('user_address_detail', e.target.value)}
              placeholder="나머지 주소"
              style={{ ...styles.input, marginTop: 16 }}
            />
          ),
        },
        {
          key: 'address_info',
          input: (
            <Text
              style={{
                fontSize: 14,
                color: '#f61515ff',
              }}
            >
              * 상세주소가 없을 시 건물명 또는 층수를 입력해주세요.
            </Text>
          ),
        },
      ],
    },
    {
      label: '닉네임',
      form: [
        {
          key: 'user_nickname',
          input: (
            <Input
              value={inputValue.user_nickname}
              onChange={(e) => onChange('user_nickname', e.target.value)}
              placeholder="닉네임을 입력해주세요."
              style={{ ...styles.input }}
            />
          ),
          x: 18,
        },
      ],
    },
    {
      label: '성별',
      form: [
        {
          key: 'user_gender',
          input: (
            <Radio.Group
              value={inputValue?.user_gender}
              onChange={(e) => onChange('user_gender', e.target.value)}
              size="small"
            >
              <Radio value={'M'}>남자</Radio>
              <Radio value={'F'}>여자</Radio>
              <Radio value={null}>선택안함</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '생년월일',
      form: [
        {
          key: 'year',
          input: (
            <Input
              value={inputValue.year}
              onChange={(e) => onChange('year', e.target.value)}
              placeholder="년도"
              style={{ ...styles.input }}
              readOnly
              disabled
              suffix={'년'}
            />
          ),
          x: 12,
        },
        {
          key: 'month',
          input: (
            <Input
              value={inputValue.month}
              onChange={(e) => onChange('month', e.target.value)}
              placeholder="월"
              style={{ ...styles.input }}
              readOnly
              disabled
              suffix={'월'}
            />
          ),
          x: 6,
        },
        {
          key: 'day',
          input: (
            <Input
              value={inputValue.day}
              onChange={(e) => onChange('day', e.target.value)}
              placeholder="일"
              style={{ ...styles.input }}
              readOnly
              disabled
              suffix={'일'}
            />
          ),
          x: 6,
        },
      ],
    },
    ...(isBiz
      ? [
          {
            label: '사업자번호',
            form: [
              {
                key: 'business_num',
                input: (
                  <Input
                    value={bizInfo.business_num}
                    onChange={(e) =>
                      onChange(
                        'business_num',
                        Formatter.hyphen(e.target.value, 'business_num'),
                        setBizInfo,
                      )
                    }
                    placeholder="사업자번호"
                    style={{ ...styles.input }}
                  />
                ),
              },
            ],
          },
          // TODO: 사업자 등록증
          {
            label: '사업자 등록증',
            form: [
              {
                key: 'business_num_url',
                input: !bizInfo.business_num_url ? (
                  <Button
                    icon={<UploadOutlined />}
                    onClick={() => fileRef.current.click()}
                  >
                    사업자 등록증 업로드
                    <input
                      ref={fileRef}
                      type="file"
                      style={{ display: 'none' }}
                      onChange={(e) =>
                        onChange(
                          'business_num_url',
                          e.target.files[0],
                          setBizInfo,
                        )
                      }
                      accept="image/*"
                    />
                  </Button>
                ) : (
                  <Flex align="center" gap={4}>
                    <Image
                      src={
                        typeof businessFile === 'string'
                          ? `${STORE_URL}/${bizInfo.business_num_url}`
                          : URL.createObjectURL(bizInfo.business_num_url)
                      }
                      alt="사업자등록증"
                      width={150}
                      height={250}
                    />

                    <Button
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() =>
                        onChange('business_num_url', null, setBizInfo)
                      }
                    />
                  </Flex>
                ),
              },
            ],
          },
          {
            label: '원두 월 사용 예상량',
            form: [
              {
                key: 'month_use',
                input: (
                  <Input
                    value={monthUse}
                    onChange={(e) => setMonthUse(e.target.value)}
                    placeholder="월 원두 사용량을 작성해주세요"
                    style={{ ...styles.input }}
                  />
                ),
              },
            ],
          },
        ]
      : []),
  ];

  /* ===== FUNCTION ===== */
  /**
   * 다음 주소 API
   * --
   */
  const handleAddressModal = () => {
    openAddressModal((res) => {
      const { address, zonecode } = res;

      onChange('user_address', address);
      onChange('postcode', zonecode);
    });
  };

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <TopBanner
        maxWidth={1820}
        height={48}
        closable={false}
        onClick={() => window.open(`${DOMAIN_URL}/#/common/apply`)}
      >
        <p style={{ fontSize: 14 }}>입점 제안</p>
      </TopBanner>

      <Content
        maxWidth={1820}
        padding={screenSize >= 768 ? '100px 0px' : '60px 0'}
      >
        <Row gutter={16}>
          <Col x={0} md={3} xl={8}></Col>
          <Col x={24} md={18} xl={8}>
            <Title align={'center'} style={{ ...styles.title }}>
              Join Member
            </Title>

            {!isBiz ? (
              <Flex
                style={{
                  marginTop: screenSize >= 768 ? 20 : 10,
                  marginBottom: screenSize >= 768 ? -40 : -20,
                }}
                align="center"
                justify="center"
                gap={24}
              >
                <Text size={12} color={'var(--danger-color)'}>
                  사업자 회원이신가요?
                </Text>

                <Button onClick={() => navigate(`/signup?biz=partner`)}>
                  사업자로 가입하기
                </Button>
              </Flex>
            ) : null}

            <div
              style={{
                marginTop: screenSize >= 768 ? 80 : 40,
                borderBottom: '1px solid var(--black-color)',
              }}
            >
              <p
                style={{
                  ...styles.infoText,
                  paddingBottom: 2,
                }}
              >
                <span style={{ ...styles.required }}>*</span>
                필수 입력사항
              </p>
            </div>

            {/* 입력 폼 */}
            <Content maxWidth={'100%'} padding={'40px 0px 60px'}>
              {formItem.map((_item, _index) =>
                !_item ? null : (
                  <Row gutter={[16]} key={`form_item_${_index}`}>
                    <Col x={24} style={{}}>
                      <p style={{ ...styles.label }}>
                        {_item.label}
                        {_item.required && (
                          <span style={{ ...styles.required }}>*</span>
                        )}
                      </p>
                    </Col>
                    <Col x={24}>
                      <Row
                        gutter={16}
                        style={{
                          marginBottom: screenSize >= 768 ? 24 : 20,
                          position: 'relative',
                          top: 0,
                          left: 0,
                        }}
                      >
                        {_item.form?.map((_subitem, _subindex) => (
                          <Col
                            x={_subitem.x ?? 24}
                            key={`input_${_index}_${_subindex}`}
                          >
                            <div
                              style={{
                                display: 'flex',
                                width: '100%',
                                height: '100%',
                              }}
                            >
                              {_subitem.input}
                              {_subitem.key && (
                                <span
                                  style={{
                                    ...styles.message,
                                    display:
                                      status[_subitem.key] === 'error'
                                        ? 'block'
                                        : 'none',
                                  }}
                                >
                                  {message[_subitem.key]}
                                </span>
                              )}
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </Col>
                  </Row>
                ),
              )}
            </Content>
            {/* 입력폼 끝 */}

            {/* 약관동의 */}
            <Content
              maxWidth={'100%'}
              padding={'28px 0px'}
              style={{
                borderTop: '2px solid var(--black-color)',
              }}
            >
              <p style={{ ...styles.label, fontSize: 16, paddingBottom: 10 }}>
                이용약관동의
                <span style={{ ...styles.required }}>*</span>
              </p>
              <Checkbox
                checked={checkedAll}
                onChange={(e) => onCheckedAll(e.target.checked)}
                style={{ ...styles.checkbox, fontWeight: 700 }}
              >
                모두 동의 (선택 정보 포함)
              </Checkbox>
              {checkListItem.map((_item, _index) => (
                <div key={`checkbox_${_item.key}`} style={{ marginTop: 20 }}>
                  <p style={{ ...styles.checkbox }}>
                    <Checkbox
                      checked={checkedList[_item.key]}
                      onChange={(e) => onChecked(_item.key, e.target.checked)}
                      style={{ ...styles.checkbox }}
                    >
                      {_item.label}

                      <span style={{ padding: '0px 5px' }}>
                        ({_item.required ? '필수' : '선택'})
                      </span>
                    </Checkbox>
                  </p>
                  {_item.url && (
                    <button
                      style={{ ...styles.more }}
                      onClick={() => navigate(`${_item.url}`)}
                    >
                      보기
                    </button>
                  )}
                </div>
              ))}
            </Content>
            {/* 약관동의 끝 */}

            {/* 버튼 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              style={{
                paddingTop: screenSize >= 768 ? 80 : 60,
                borderTop: '2px solid var(--black-color)',
              }}
            >
              <Button
                type="primary"
                style={{
                  ...styles.submitButton,
                }}
                onClick={() => onSubmit()}
              >
                가입하기
              </Button>
            </Content>
            {/* 버튼 끝 */}
          </Col>
          <Col x={0} md={3} xl={8}></Col>
        </Row>
      </Content>
    </>
  );
};

export default SignUpPresenter;
